import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './RequestBodyCell.scss';
import { EmvioPopover } from '@nexio/emvio-util-ui';

export default class RequestBodyCell extends Component {
    static propTypes = {
        body: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
    };

    constructor(props) {
        super(props);

        this.state = {};

        this.popoverButtonRef = React.createRef();
    }

    handleOpenPopover = () => {
        this.popover.openPopover(this.popoverButtonRef.current);
    };

    render() {
        return (
            <div className="action-cell request-body-cell">
                <div className="popover-btn" onClick={this.handleOpenPopover} ref={this.popoverButtonRef} >
                    {typeof this.props.body === 'object' ? (
                        <span className="json-string">{JSON.stringify(this.props.body)}</span>
                    ) : (
                        <span className="error">{this.props.body}</span>
                    )
                    }
                </div>
                <EmvioPopover
                    wrappedRef={(popover) => {
                        this.popover = popover;
                    }}>
                    {typeof this.props.body === 'object' ? (
                        <pre className="json-popover" id="json">{JSON.stringify(this.props.body, null, 2)}</pre>
                    ) : (
                        <textArea className="error-popover" disabled>{this.props.body}</textArea>
                    )
                    }
                </EmvioPopover>
            </div>
        );
    }
}
